import DefaultLayout from '@/Layouts/DefaultLayout';
import { lazy } from 'react';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { StudentRealtionsRoutes } from '@/features/studentRelations/routes/routes';
import { OrderListRoutes } from '@/features/orders/routes/routes';
import { ServiceListRoutes } from '@/features/services/routes/routes';
import { HumanResourcesRoutes } from '@/features/humanResources/routes/routes';
import { BranchesRoutes } from '@/features/branch/routes/routes';
import { SettingRoutes } from '@/features/setting/routes/routes';
import { PermissionsRoutes } from '@/features/permissions/routes/routes';
import { ReportsRoutes } from '@/features/reports/routes/routes';
import { ProductsListRoutes } from '@/features/products/routes/routes';
import { FinanceRoutes } from '@/features/finance/routes/routes';
import { NotificationsRoutes } from '@/features/notifications/routes/routes';
import { StudentByTypeRoutes } from '@/features/students_by_type/routes/routes';
import { EnrollmentsRoutes } from '@/features/enrollments/routes/routes';

// ----------------------------------------------------------------------

const Home = lazy(() => import('@/core/global-pages/Home'));
const SoonPage = lazy(() => import('@/core/global-pages/SoonPage'));

// ----------------------------------------------------------------------

const routes = [
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        children: [
            { index: true, element: <Home /> },
            {
                path: '/coming-soon',
                element: <SoonPage />,
                layout: 'default',
                isAuthReq: true,
            },

            ...StudentRealtionsRoutes,
            ...OrderListRoutes,
            ...ServiceListRoutes,
            ...HumanResourcesRoutes,
            ...BranchesRoutes,
            ...SettingRoutes,
            ...PermissionsRoutes,
            ...ReportsRoutes,
            ...ProductsListRoutes,
            ...FinanceRoutes,
            ...NotificationsRoutes,
            ...StudentByTypeRoutes,
            ...EnrollmentsRoutes,
        ],
    },
    ...LoginRoutes,
];
export { routes };
